import React from "react";
import { Link } from "react-router-dom";
import '../Styles/AdultsLandingPage.scss';
function AdultsLandingPage() {
   return (
      <div>
         <div className="adultLandingPageContent">
            <div className="adultLandingPageContainer">
               <div className="adultLandingPageTitleContainer">
                  <div className="adultLandingPageTitle">
                     Adult Events and Retreats
                  </div>
               </div>
               <div className="adultLandingPageDescription">
                     Adult Camps give adult campers
                     exciting summer activities to be
                     encouraged and challenged. There 
                     are four exciting camps to choose from
               </div>
               <div className="adultLandingPageCampsRow1">
                     <div className="couplesRetreat">
                        <div className="couplesRetreatTitle">
                           Couples' Retreat
                        </div>
                        <div className="couplesRetreatContent">
                           Couples' Retreat is a
                           week of bonding experiences.
                           Couples stay overnight in cabins.
                        </div>
                        <div className="couplesRetreatButton">
                           <Link to={"/couples"}><button>Learn More</button></Link>
                        </div>
                     </div>

                  <div className="mensChallenge">
                     <div className="mensChallengeTitle">
                        Mens' Challenge
                     </div>
                     <div className="mensChallengeContent">
                     Mens' Challenge is a exciting experience for men of all ages
                     Men can look forward to an invigorating time
                     of fellowship
                     </div>
                     <div className="mensChallengeButton">
                        <Link to={"/men"}><button>Learn More</button></Link>
                     </div>
                  </div>

               </div>

               <div className="adultLandingPageCampsRow2">
                     <div className="ladiesRetreat">
                        <div className="ladiesRetreatTitle">
                           Ladies' Retreat
                        </div>
                        <div className="ladiesRetreatContent">
                           Ladies' Retreat is a refreshing
                           time of fellowship.
                           Ladies will enjoy worship and a welcoming atmosphere
                        </div>
                        <div className="ladiesRetreatButton">
                           <Link to={"/ladies"}><button>Learn More</button></Link>
                        </div>
                     </div>

                  <div className="youngAdultsRetreat">
                     <div className="youngAdultsRetreatTitle">
                        Young Adults' Retreat
                     </div>
                     <div className="youngAdultsRetreatContent">
                     Young Adults' Retreat is a beautiful fall excursion for college-aged
                     adults. Campers can enjoy the beautiful fall weather.
                     </div>
                     <div className="youngAdultsRetreatButton">
                        <Link to={"/youngadults"}><button>Learn More</button></Link>
                     </div>
                  </div>

               </div>



            </div>
         </div>
      </div>
   )
}
export default AdultsLandingPage;
